import WebFont from 'webfontloader'

export default () => {
  WebFont.load({
    google: {
      families: ['Roboto']
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/_fonts.js